import React, { useEffect, useState } from "react";
import Breadcrums from "../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import * as productAttributeManagement from "../../../services/productAttributeManagement";
import * as productManagement from "../../../services/productManagement";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "rsuite";
import { capitalizeFirstLetter } from "../../../../../utils/commonfunction";

const ViewAttributes = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [attribute, setAttribute] = useState({});
    const [categories, setCategories] = useState([]);

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: "Attributes",
            url: "/admin/productManagement/attributes/list/1",
        },
        { title: "View", url: "" },
    ];

    useEffect(() => {
        // Fetch categories for mapping names if needed
        productManagement.List({ page: 1, per_page: 1000 }).then(res => {
            if (res.success) {
                setCategories(res.data.list);
            }
        });

        productAttributeManagement
            .Details(params.id)
            .then((response) => {
                setAttribute(response && response.data ? response.data : {});
                setDataLoaded(true);
            })
            .catch((error) => {
                console.error("error=====>", error);
                setDataLoaded(true);
            });
    }, [params.id]);

    const category = categories.find(c => c._id === attribute.categoryId);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="main-content-label mb-3">Attribute Details</h6>
                                </div>

                                <div className="table-responsive">
                                    <table id="simple-table" className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: "20%" }}>Attribute Name</th>
                                                <td>{attribute.name || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Category</th>
                                                <td>{category ? category.title : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Type</th>
                                                <td>{attribute.attributeType ? capitalizeFirstLetter(attribute.attributeType) : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Description</th>
                                                <td>{attribute.description || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Status</th>
                                                <td>
                                                    <span className={`badge ${attribute.status === 1 ? "bg-success" : "bg-danger"}`}>
                                                        {attribute.status === 1 ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Visible in Filter</th>
                                                <td>{attribute.isVisibleInFilter ? "Yes" : "No"}</td>
                                            </tr>
                                            {!['text', 'number'].includes(attribute.attributeType) && (
                                                <tr>
                                                    <th>Predefined Values</th>
                                                    <td>
                                                        <div className="d-flex flex-wrap gap-2">
                                                            {attribute.values && attribute.values.length > 0 ? (
                                                                attribute.values.map((v, i) => (
                                                                    <span key={i} className="badge bg-light text-dark border">
                                                                        {typeof v === 'object' && v !== null ? v.name : v}
                                                                    </span>
                                                                ))
                                                            ) : "No values defined"}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-4 d-flex">
                                    <button
                                        className="btn btn-main-primary signbtn mr-2"
                                        onClick={() => navigate(`/admin/productManagement/attributes/edit/${attribute._id}`)}
                                    >
                                        <i className="ri-pencil-line me-1"></i> Edit Attribute
                                    </button>
                                    <button
                                        className="btn ripple btn-dark"
                                        type="button"
                                        onClick={() =>
                                            navigate("/admin/productManagement/attributes/list/1")
                                        }
                                    >
                                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                        {t("btn_back")}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center p-5">
                    <Loader size="md" content="Loading..." vertical />
                </div>
            )}
        </>
    );
};

export default ViewAttributes;
